/**
 * Log levels.
 * @public
 */
export enum Levels {
  error,
  warn,
  log,
  debug
}
